function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ParamValidator from '@rd-web-markets/shared/dist/models/ParamValidator';
import { FormattedNumberInput, Table } from '@rd-web-markets/shared/dist/util';
import React from 'react';
import benefitAdjustmentsService from '../../services/claim/benefit_adjustments.service';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import { replaceInArray } from '@rd-web-markets/shared/dist/util/arrayUtils/arrayUtils';

/**
 * type
 */
export default function BenefitAdjustmentsTable(_ref) {
  let {
    claim,
    type,
    setLoading,
    adjustments,
    setAdjustments
  } = _ref;
  ParamValidator.validateValueIn('BenefitAdjustmentsTable', type, ['adduction', 'deduction']);
  const createAdjustment = benefitAdjustmentsService.useCreate({
    claimId: claim.id,
    setLoading,
    setAdjustments
  });
  const updateAdjustment = benefitAdjustmentsService.useUpdate({
    claimId: claim.id,
    setLoading,
    setAdjustments
  });
  const deleteAdjustment = benefitAdjustmentsService.useDelete({
    claimId: claim.id,
    setLoading,
    setAdjustments
  });
  const removeAdjustment = adjustment => {
    if (adjustment.id && !(typeof adjustment.id === 'string')) {
      deleteAdjustment(adjustment);
    } else {
      setAdjustments([...adjustments.filter(a => a.id !== adjustment.id)]);
    }
  };
  const updateOrCreateAdjustment = adjustment => {
    if (typeof adjustment.id === 'string') {
      createAdjustment({
        adjustment_type: adjustment.adjustment_type,
        amount: adjustment.amount
      });
    } else {
      updateAdjustment(adjustment);
    }
  };
  if (!adjustments) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  const headers = [{
    text: ''
  }, {
    text: ''
  }];
  const rows = adjustments.filter(adjustment => adjustment.adjustment_type === type).map(adjustment => ({
    data: {
      object: adjustment
    },
    key: adjustment.id,
    columns: [/*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
      as: FormattedNumberInput,
      onChange: _ref2 => {
        let {
          target: {
            value: amount
          }
        } = _ref2;
        return setAdjustments(replaceInArray(a => a.id === adjustment.id, _objectSpread(_objectSpread({}, adjustment), {}, {
          amount
        })));
      },
      onBlur: () => updateOrCreateAdjustment(adjustment),
      disabled: claim.financials_locked,
      name: "amount",
      style: {
        textAlign: 'right'
      },
      object: _objectSpread(_objectSpread({}, adjustment), {}, {
        claim: _objectSpread({}, claim)
      })
    })]
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, rows.length ? /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    onDelete: (index, row) => removeAdjustment(row.data.object)
  }) : '');
}